import { IUnitDetailsDto } from "api/api";

export const Has2gModem = (machine: IUnitDetailsDto) => {
    return machine.modemName?.toLocaleLowerCase().includes('2g');
};
